// extracted by css-extract-rspack-plugin
export default {"toggle":"VvNXtl","tooltip":"qZcpfc","badge-icon":"KEr0tm","badgeIcon":"KEr0tm"};